<template>
    <div class="dashboard-page">
        <div class="page-box">
            <div class="panel-box summary">
                <div class="box source-chart-v">
                    <div class="panel" @click="goReportList()">
                        <div class="right-num">
                            <span>报告数量：</span>
                            <i>{{ numFormat(reportCountMap['count']) }}</i>
                        </div>
                    </div>
                    <div class="panel panel-yesCount" @click="goReportList()">
                        <div class="right-num">
                            <span>已发布报告：</span>
                            <i>{{ numFormat(reportCountMap['yesCount']) }}</i>
                        </div>
                    </div>
                    <div class="panel panel-noCount" @click="goReportList()">
                        <div class="right-num">
                            <span>制作中报告：</span>
                            <i>{{ numFormat(reportCountMap['noCount']) }}</i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="list-box">
                <div class="content-wrapper " ref="content">
                    <el-table
                        v-loading="loading"
                        :data="authorReportCountList"
                        stripe
                        header-row-class-name='admin-header'
                        style="width: 100%"
                        min-height="520"
                        height="calc(100% - 52px)"
                        class='account_table'>
                        <template slot="empty">
                            <span :class="[loading ? 'empty-null' : 'empty-show']">暂无数据</span>
                        </template>
                        <el-table-column type="index" label="序号" width="100"> </el-table-column>
                        <el-table-column prop="name" label="创作者"></el-table-column>
                        <el-table-column prop="mobile" label="手机号"></el-table-column>
                        <el-table-column prop="count" label="报告数量"></el-table-column>
                        <el-table-column prop="yesCount" label="已发布报告"></el-table-column>
                        <el-table-column prop="noCount" label="制作中报告"></el-table-column>
                        <el-table-column prop="lastLoginTime" label="最后登录时间" width='170'></el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="panel-box echarts-pie">
                <PieChart :dataList="customerReportCountList"></PieChart>
            </div>
            <div class="panel-box echarts-line">
                <LineChart :data="dateReportCountMap"></LineChart>
            </div>
        </div>
    </div>
</template>
<script>
    import '@/assets/css/dashboard.css'
    import { dateTime, numFormat } from '../assets/js/common.js'
    import { getStatisticReportCount, getStatisticAuthorReportCount, getStatisticCustomerReportCount, getStatisticDateReportCount, getAccountInfo } from '@r/api'
    import LineChart from "../components/echarts/LineChart";
    import PieChart from "../components/echarts/PieChart";


    export default {
        data() {
            return {
                reportCountMap: {
                    count: 0,
                    yesCount: 0,
                    noCount: 0
                },
                authorReportCountList: [],
                customerReportCountList: [],
                dateReportCountMap: {},
                loading: true,
                numFormat: numFormat,
            }
        },
        computed: {},
        created() {},
        components: {
            PieChart,
            LineChart
        },
        mounted() {
            this.$store.commit('menuIndex', 'dashboard')
            sessionStorage.setItem('index', 'dashboard')
            this.getAccountInfo()
            this.getStatisticReportCount();
            this.getStatisticAuthorReportCount();
            this.getStatisticCustomerReportCount();
            this.getStatisticDateReportCount();
        },
        methods: {
            getStatisticReportCount(){
                getStatisticReportCount({
                }).then(data => {
                    this.reportCountMap = data
                })
            },
            getStatisticAuthorReportCount(){
                let that = this
                this.loading = true

                getStatisticAuthorReportCount({
                }).then(data => {
                    this.authorReportCountList = data
                    that.loading = false
                })
            },
            getStatisticCustomerReportCount(){
                let that = this

                let endTime = new Date().getTime() + 24 * 3600 * 1000;
                let startTime = endTime - 30 * 24 * 3600 * 1000;

                getStatisticCustomerReportCount({
                    scope: 'user',
                    start: dateTime(startTime).replaceAll('.', '-'),
                    end: dateTime(endTime).replaceAll('.', '-')
                }).then(data => {
                    if(data != null) {

                        data.sort((a, b) => {
                            return b.count - a.count;
                        });

                        data.forEach((v) => {
                            that.customerReportCountList.push({
                                value: v.count,
                                name: v.simple_name + " (" + v.count + ")"
                            })
                        })
                    }
                })
            },
            getStatisticDateReportCount(){

                let endTime = new Date().getTime();
                let startTime = endTime - 30 * 24 * 3600 * 1000;

                getStatisticDateReportCount({
                    scope: 'user',
                    start: dateTime(startTime).replaceAll('.', '-'),
                    end: dateTime(endTime).replaceAll('.', '-')
                }).then(data => {
                    let xData = [], yData = [];

                    if(data) {
                        for(let key in data) {
                            xData.push(key);
                        }
                        xData.sort();
                        xData.forEach(v => {
                            yData.push(data[v]);
                        })
                    }

                    this.dateReportCountMap = {
                        'xData': xData,
                        'yData': yData
                    }
                })
            },
            goReportList() {
                this.$store.commit('menuIndex', 'reportList')
                this.$router.push({ path: '/report/list' })
            },
            getAccountInfo(){
                return new Promise((resolve, reject) => {
                    getAccountInfo({}).then(data => {
                        if (data && data.info) {
                            this.$cookies.remove('user_info')
                            this.$cookies.set('user_info', JSON.stringify(data.info))
                        }
                        resolve()
                    }).catch(() => {
                        reject()
                    })
                })
            },
        }
    }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/dashboard.vue